import * as React from 'react'
import type { SVGProps } from 'react'

import { PijmaComponent } from '@pijma/helper-component'
import { CommonComponentProps } from '@pijma/hero-types'

export const IconHelp = (
  props: SVGProps<SVGSVGElement> & CommonComponentProps,
) => (
  <PijmaComponent
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    as="svg"
    commonProps={props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM9.00259 7.27314C9.70164 6.4867 10.7286 6 12 6C12.9599 6 13.9288 6.31663 14.6764 6.89815C15.4349 7.48809 16 8.38576 16 9.5C16 10.4315 15.7617 11.1554 15.3251 11.7253C14.9126 12.2639 14.3798 12.582 14.0039 12.8013L13.9499 12.8327C13.5555 13.0627 13.3524 13.1811 13.2036 13.3423C13.1047 13.4494 13 13.6083 13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 13.1417 11.2703 12.4881 11.7339 11.9858C12.0997 11.5895 12.5692 11.3195 12.8927 11.1335L12.8929 11.1334C12.9293 11.1124 12.9638 11.0926 12.9961 11.0737C13.3702 10.8555 13.5874 10.7049 13.7374 10.5091C13.8633 10.3446 14 10.0685 14 9.5C14 9.11424 13.8151 8.76191 13.4486 8.47685C13.0712 8.18337 12.5401 8 12 8C11.2714 8 10.7984 8.2633 10.4974 8.60186C10.1801 8.95883 10 9.46307 10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 9.03693 8.3199 8.04117 9.00259 7.27314ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
      fill="currentColor"
    />
  </PijmaComponent>
)
